import { object, number } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  deviceId: number().nullable().required('Field is required'),
});

export default yupResolver(validationSchema);
